import React from 'react'
// components
import MinimizedObjectivesList from 'components/PageComponents/Plans/Edit/components/MinimizedObjectivesList/index'
import MinimizedObjectivesListActions from 'containers/MinimizedObjectivesList/layers/Business/Actions'
import MinimizedObjectivesListAPI from 'containers/MinimizedObjectivesList/layers/API'

const ParentPlanObjectivesListContainer: React.FC<any> = props => (
  <MinimizedObjectivesListAPI>
    <MinimizedObjectivesListActions>
      <MinimizedObjectivesList {...(props as any)} />
    </MinimizedObjectivesListActions>
  </MinimizedObjectivesListAPI>
)

export default ParentPlanObjectivesListContainer
